import { TableColumn } from '@backstage/core-components';
import { CatalogTableRow } from '@backstage/plugin-catalog';
import { EntityRefLink } from '@backstage/plugin-catalog-react';
import Box from '@mui/material/Box';
import PersonIcon from '@mui/icons-material/Person';
import {
  BU_ANNOTATION,
  MANAGER_EMAIL_ANNOTATION,
  PU_ANNOTATION,
  annotationValue,
  emailToUserRef,
  nameFromEmail,
} from './utils';

export const userColumns: TableColumn<CatalogTableRow>[] = [
  {
    title: 'Name',
    field: 'resolved.entityRef',
    highlight: true,
    customSort({ entity: e1 }, { entity: e2 }) {
      type Profile = { displayName?: string };
      const t1 =
        (e1.spec?.profile as unknown as Profile)?.displayName ??
        e1.metadata.name;
      const t2 =
        (e2.spec?.profile as unknown as Profile)?.displayName ??
        e2.metadata.name;
      return t1.localeCompare(t2);
    },
    render: ({ entity }) => {
      type Profile = { displayName?: string };
      const displayName =
        (entity.spec?.profile as unknown as Profile)?.displayName ??
        entity.metadata.name;
      return (
        <EntityRefLink entityRef={entity} defaultKind="user">
          {displayName}
        </EntityRefLink>
      );
    },
  },
  {
    title: 'Manager',
    field: `entity.metadata.annotations.${MANAGER_EMAIL_ANNOTATION}`,
    render: ({ entity }) => {
      const email =
        entity.metadata.annotations?.[MANAGER_EMAIL_ANNOTATION] ?? '';
      const ref = emailToUserRef(email);
      const displayName = nameFromEmail(email);
      if (!ref) return <>—</>;
      const content = (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <PersonIcon fontSize="small" style={{ marginRight: 8 }} />
          <span>{displayName}</span>
        </Box>
      );
      return (
        <EntityRefLink entityRef={ref} defaultKind="user" hideIcon>
          {content}
        </EntityRefLink>
      );
    },
  },
  {
    title: 'Business Unit',
    field: `entity.metadata.annotations.${BU_ANNOTATION}`,
    render: ({ entity }) => annotationValue(entity, BU_ANNOTATION),
  },
  {
    title: 'Product Unit',
    field: `entity.metadata.annotations.${PU_ANNOTATION}`,
    render: ({ entity }) => annotationValue(entity, PU_ANNOTATION),
  },
];
